// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest} from '@/libs/axios';


// 分页获取消息信息
export const _getByPage = (params) => {
    return postRequest('/copyrightregister/getByPage2', params)
};

// 获取登记详情信息
export const _getDetail = (params) => {
    return getRequest('/copyrightregister/getDetail', params)
};


//版权登记 POST /bqjvip/copyrightRegisterDci/save
export const _save = (params) => {
    return postRequest('/copyrightregister/save', params)
};
//POST /bqjvip/copyrightRegisterDci/reSubmit
export const _resubmit = (params) => {
    return postRequest('/copyrightregister/reSubmit', params)
}

//版权登记-折扣登记提交
export const _discountSave = (params) => {
    return postRequest('/copyrightregister/discount/save', params)
};
//版权登记-折扣重新提交
export const _discountResubmit = (params) => {
    return postRequest('/copyrightregister/discount/reSubmit', params)
}


//获取作品类型列表
export const _getWorkTypeList = (params) => {
    return getRequest('/copyrightregister/getWorkTypeList', params)
}

//版权登记查询-短信验证码
export const _sendSmsCode = (params) => {
    return postRequest('/yccrm/sendSmsCode', params)
};

//版权登记查询-提交
export const _insertCustom = (params) => {
    return postRequest('/yccrm/insertCustom', params)
};




